import React from "react";
import { ScreenHeader } from "./ScreenHeader";
import { useProfile } from "@moonscape/shared";
import { Link, useLocation, useRouteMatch } from "react-router-dom";
import { useAccountantView } from "@/contexts";
import { AccountantBanner } from "./AccountantBanner";
import { cn } from "@/utils/shadcn";
import { Callout, Pill } from "@/components/ms";

export const Screen = ({
  children,
  heading,
  className,
}: {
  children: React.ReactNode;
  heading?: string;
  className?: string;
}) => {
  const { profile } = useProfile();
  const isDemo = profile?.isDemo;
  const { path } = useRouteMatch();
  const location = useLocation();
  const { isViewingClient, clientName } = useAccountantView();

  // Add check for exchange settings route
  const isExchangeSettingsRoute = path === "/settings";
  const showAccountantBanner = isViewingClient
    && !!clientName
    && !location.pathname.startsWith("/a/");

  return (
    <div data-id="screen-data-id" className="flex flex-1 flex-col">
      <ScreenHeader heading={heading} />
      {showAccountantBanner && <AccountantBanner clientName={clientName || "Client"} />}
      {/* The screen's one alert bar is the shell's ShellAlert slot; the demo notice
          is therefore demoted to a box, per the spec's merge rule. */}
      {isDemo && !isExchangeSettingsRoute && (
        <div className="px-[var(--pad)] pt-[var(--gap)]">
          <Callout tone="caution" title="You're looking at demo data">
            Connect a source and the same screens fill with your own history.
            <span className="mt-3 block">
              <Pill as={Link} to="/settings/exchange/new">
                Connect exchange
              </Pill>
            </span>
          </Callout>
        </div>
      )}
      <div className={cn("mx-auto w-full max-w-[1320px] px-[var(--pad)] py-[var(--gap)]", className)}>
        {children}
      </div>
    </div>
  );
};
